/** Static menu reference — ordering by phone only */

export const FOOD_ITEMS = [
    //sets
    {
        id: 101,
        nameRus: 'Сет Пробный (Свинина, Курица)',
        descriptionRus: '',
        price: 3700,
        weight: "1.7кг",
        image: "set_trial",
        category: "sets"
    },
    {
        id: 102,
        nameRus: 'Сет из баранины',
        descriptionRus: '',
        price: 6500,
        weight: "2.2кг",
        image: "set_lamb",
        category: "sets"
    },
    {
        id: 103,
        nameRus: 'Сет из курицы',
        descriptionRus: '',
        price: 4300,
        weight: "2.2кг",
        image: "set_chicken",
        category: "sets"
    },
    {
        id: 104,
        nameRus: 'Сет на большую компанию (Ассорти)',
        descriptionRus: '',
        price: 8500,
        weight: "3.7кг",
        image: "set_big_company",
        category: "sets"
    },
    //vegetables
    {
        id: 205,
        nameRus: 'Баклажан',
        descriptionRus: '',
        price: 260,
        weight: "100г",
        image: "vegetables_eggplant",
        category: "vegetables"
    },
    {
        id: 206,
        nameRus: 'Кукуруза',
        descriptionRus: '',
        price: 320,
        weight: "240г",
        image: "vegetables_corn",
        category: "vegetables"
    },
    {
        id: 207,
        nameRus: 'Молодой картофель',
        descriptionRus: '',
        price: 260,
        weight: "200г",
        image: "vegetables_potatoes",
        category: "vegetables"
    },
    {
        id: 208,
        nameRus: 'Овощи ассорти',
        descriptionRus: '',
        price: 680,
        weight: "520г",
        image: "vegetables_assorted",
        category: "vegetables"
    },
    {
        id: 209,
        nameRus: 'Острый перец',
        descriptionRus: '',
        price: 250,
        weight: "100г",
        image: "vegetables_pepper_hot",
        category: "vegetables"
    },
    {
        id: 210,
        nameRus: 'Перец болгарский',
        descriptionRus: '',
        price: 220,
        weight: "100г",
        image: "vegetables_pepper_bulgarian",
        category: "vegetables"
    },
    {
        id: 211,
        nameRus: 'Шампиньоны',
        descriptionRus: '',
        price: 280,
        weight: "120г",
        image: "vegetables_champignons",
        category: "vegetables"
    },
    // shashliks
    {
        id: 301,
        nameRus: 'Люля-кебаб из баранины',
        descriptionRus: '',
        price: 640,
        weight: "170г",
        image: "shashlik_kebab",
        category: "shashliks"
    },
    {
        id: 302,
        nameRus: 'Люля-кебаб из курицы',
        descriptionRus: '',
        price: 550,
        weight: "170г",
        image: "shashlik_kebab_chicken",
        category: "shashliks"
    },
    {
        id: 303,
        nameRus: 'Люля-кебаб из говядины',
        descriptionRus: '',
        price: 580,
        weight: "170г",
        image: "shashlik_kebab",
        category: "shashliks"
    },
    {
        id: 304,
        nameRus: 'Цыпленок на мангале',
        descriptionRus: '',
        price: 720,
        weight: "300г",
        image: "shashlik_chicken_full",
        category: "shashliks"
    },
    {
        id: 305,
        nameRus: 'Шашлык из куриного бедра',
        descriptionRus: '',
        price: 650,
        weight: "220г",
        image: "shashlik_chicken_hip",
        category: "shashliks"
    },
    {
        id: 306,
        nameRus: 'Шашлык из куриных крыльев',
        descriptionRus: '',
        price: 680,
        weight: "210г",
        image: "shashlik_chicken_wings",
        category: "shashliks"
    },
    {
        id: 307,
        nameRus: 'Шашлык из бараньих семечек',
        descriptionRus: '',
        price: 780,
        weight: "220г",
        image: "shashlik_mutton_ribs",
        category: "shashliks"
    },
    {
        id: 308,
        nameRus: 'Шашлык из корейки ягненка',
        descriptionRus: '',
        price: 1100,
        weight: "250г",
        image: "shashlik_lamb_rack",
        category: "shashliks"
    },
    {
        id: 309,
        nameRus: 'Шашлык из мякоти ягненка',
        descriptionRus: '',
        price: 1100,
        weight: "220г",
        image: "shashlik_lamb",
        category: "shashliks"
    },
    {
        id: 310,
        nameRus: 'Шашлык из говяжьей вырезки',
        descriptionRus: '',
        price: 1100,
        weight: "220г",
        image: "shashlik_beef",
        category: "shashliks"
    },
    {
        id: 311,
        nameRus: 'Шашлык из свиной шейки',
        descriptionRus: '',
        price: 680,
        weight: "220г",
        image: "shashlik_pork_neck",
        category: "shashliks"
    },
    {
        id: 312,
        nameRus: 'Шашлык из свиной корейки',
        descriptionRus: '',
        price: 680,
        weight: "260г",
        image: "shashlik_pork_rack",
        category: "shashliks"
    },
    {
        id: 313,
        nameRus: 'Шашлык из свиных ребрышек',
        descriptionRus: '',
        price: 680,
        weight: "230г",
        image: "shashlik_pork_ribs",
        category: "shashliks"
    },
    // salads
    {
        id: 401,
        nameRus: 'Салат Домашний',
        descriptionRus: '',
        price: 420,
        weight: "250г",
        image: "salad_homemade",
        category: "salads"
    },
    {
        id: 402,
        nameRus: 'Салат Цезарь с куриной грудкой',
        descriptionRus: '',
        price: 540,
        weight: "250г",
        image: "salad_caesar",
        category: "salads"
    },
    {
        id: 403,
        nameRus: 'Салат с хрустящими баклажанами',
        descriptionRus: '',
        price: 520,
        weight: "250г",
        image: "salad_with_eggplants",
        category: "salads"
    },
    //pizzas
    {
        id: 501,
        nameRus: 'Пицца Пепперони',
        descriptionRus: '',
        price: 1400,
        weight: "250г",
        image: "pizza_pepperoni",
        category: "pizzas"
    },
    {
        id: 502,
        nameRus: 'Пицца с куриной грудкой',
        descriptionRus: '',
        price: 1400,
        weight: "250г",
        image: "pizza_chicken",
        category: "pizzas"
    },
    //drinks
    {
        id: 601,
        nameRus: 'Coca Cola',
        descriptionRus: '',
        price: 250,
        weight: "250мл",
        image: "drinks_coca_cola",
        category: "drinks"
    },
    {
        id: 602,
        nameRus: 'Sprite',
        descriptionRus: '',
        price: 300,
        weight: "330мл",
        image: "drinks_sprite",
        category: "drinks"
    },
    {
        id: 603,
        nameRus: 'Fanta',
        descriptionRus: '',
        price: 300,
        weight: "330мл",
        image: "drinks_fanta",
        category: "drinks"
    },
    {
        id: 604,
        nameRus: 'Rich апельсиновый',
        descriptionRus: '',
        price: 200,
        weight: "200мл",
        image: "drinks_rich_orange",
        category: "drinks"
    },
    {
        id: 605,
        nameRus: 'Rich вишневый',
        descriptionRus: '',
        price: 200,
        weight: "200мл",
        image: "drinks_rich_cherry",
        category: "drinks"
    },
    {
        id: 606,
        nameRus: 'Джермук',
        descriptionRus: '',
        price: 250,
        weight: "500мл",
        image: "drinks_jermuk",
        category: "drinks"
    },
    //sauces
    {
        id: 701,
        nameRus: 'Кимчи',
        descriptionRus: '',
        price: 100,
        weight: "50г",
        image: "sauces",
        category: "sauces"
    },
    {
        id: 702,
        nameRus: 'Сацебели',
        descriptionRus: '',
        price: 100,
        weight: "50г",
        image: "sauces",
        category: "sauces"
    },
    {
        id: 703,
        nameRus: 'Чесночный',
        descriptionRus: '',
        price: 100,
        weight: "50г",
        image: "sauces",
        category: "sauces"
    },
    //bread

]